// Ops Dashboard: the routes and the sidebar rows of `wealth.ops.dashboard` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.ops.dashboard',
    routes: [
        { frontend: 'ops', path: '', lazy: () => import('@/pages/ops/page') },
        {
            frontend: 'ops',
            path: 'dashboard',
            lazy: () => import('@/pages/ops/command-centre/page'),
        },
        {
            frontend: 'ops',
            path: 'command-centre',
            lazy: () => import('@/pages/ops/command-centre/page'),
        },
    ],
    nav: [
        {
            frontend: 'ops',
            key: 'command-centre',
            label: 'Ops Dashboard',
            href: '/ops/dashboard',
            icon: 'LayoutDashboard',
            group: 'overview',
            order: 110,
            aliases: ['/ops/command-centre'],
        },
    ],
});
